export default import.meta.ROLLDOWN_FILE_URL_wyAwyQO7h5ix5xRZ0IFJHQ